import { useQuery } from '@tanstack/react-query';
import { API } from '~/shared/API/api';
import { useUserCarsStore } from '../store/userCarsStore';
import { useEffect } from 'react';

export const useGetCars = () => {
  const { state, actions } = useUserCarsStore();
  const { data, isLoading, refetch, isSuccess } = useQuery({
    queryKey: ['cars'],
    queryFn: () => API.getCars(),
    // retry: 1,
    select: (data) => data.data.payload,
    refetchOnWindowFocus: 'always',
  });

  useEffect(() => {
    if (isLoading) {
      actions.setUserCars({ loading: true, cars: state.cars });
    }
  }, [isLoading]);

  useEffect(() => {
    if (isSuccess) {
      actions.setUserCars({ loading: false, cars: data });
    }
  }, [isSuccess]);

  return { data, isLoading, refetch, isSuccess };
};
